import { useToggle } from "react-use"

import { ConnectionStatusAlert } from "./ConnectionStatusAlert"
import { connectionStatusAlertStorage } from "./Storage"

interface Props {
    bookingHash: string
    isMyConnectionBad: boolean
    isPeerConnectionBad: boolean
    toggleHelpModal: () => void
}

export function ConnectionStatus({
    bookingHash,
    isMyConnectionBad,
    isPeerConnectionBad,
    toggleHelpModal,
}: Props) {
    const data = connectionStatusAlertStorage.get(bookingHash)
    const [isMyConnectionBadShow, setIsMyConnectionBadShow] = useToggle(data.isMyConnectionBadShow)
    const [isPeerConnectionBadShow, setIsPeerConnectionBadShow] = useToggle(
        data.isPeerConnectionBadShow
    )

    function handleCloseMy() {
        setIsMyConnectionBadShow()
        connectionStatusAlertStorage.updateStore("isMyConnectionBadShow", false, bookingHash)
    }

    function handleClosePeer() {
        setIsPeerConnectionBadShow()
        connectionStatusAlertStorage.updateStore("isPeerConnectionBadShow", false, bookingHash)
    }

    return (
        <>
            {isMyConnectionBad && isMyConnectionBadShow && (
                <ConnectionStatusAlert
                    text="У вас плохое соединение"
                    toggleHelpModal={toggleHelpModal}
                    close={handleCloseMy}
                />
            )}
            {isPeerConnectionBad && !isMyConnectionBad && isPeerConnectionBadShow && (
                <ConnectionStatusAlert
                    text="У собеседника плохое соединение"
                    toggleHelpModal={toggleHelpModal}
                    close={handleClosePeer}
                />
            )}
        </>
    )
}
